/**
 * Company: SPHMedia
 * Description: International Global Layout
 */

import { ReactElement } from "react";
import { Helmet } from "react-helmet-async";
import { VerticalProps } from "@app/types/Verticals";
import Breadcrumb from "@components/Breadcrumb/Breadcrumb";
import Container from "@components/Container/Container";
import Header from "@components/Header/Header";
import {
  BT_NEWSLETTERS,
  NEWSLETTER_TYPE,
} from "@components/Newsletter/types/Newsletter";
import NewsletterSignUpPanel from "@components/Newsletter/Verticals/NewsletterSignUp";
import KeywordStoriesRow from "@pages/Section/components/VerticalMeta/KeywordStoriesRow";
import LatestStoriesRow from "@pages/Section/components/VerticalMeta/LatestStoriesRow";
import TopStoriesRow from "@pages/Section/components/VerticalMeta/TopStoriesRow";
import { sectionNavigationItems } from "@util/constant";

import AseanBanner from "./components/AseanBanner";
import AseanNewsletterDescription from "./components/AseanNewsletterDescription";

export default function AseanBusinessVertical({
  context,
  mostReadArticles,
}: VerticalProps): ReactElement {
  const {
    data: { title, topStories, additional },
  } = context;

  return (
    <div className="w-full">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Header />

      <div className="flex-none bg-[var(--digital-breadcrumb-light-gray)]">
        <Breadcrumb
          rootClassName="m-auto container"
          parentCategory="international"
          childCategory="global"
          categoryDataMapping={sectionNavigationItems}
        />
      </div>

      <AseanBanner />

      <Container rootClassName="mt-6 px-3">
        <TopStoriesRow
          parentCategory="international/asean"
          articles={topStories}
          verticalName="asean"
        />

        <LatestStoriesRow
          articles={topStories.slice(4, 9)}
          seeMoreLink="/international/asean/latest"
          verticalName="asean"
          mostReadStories={mostReadArticles}
        />

        <KeywordStoriesRow
          seeMoreLink="/keywords/asean"
          data={additional.at(0)}
          verticalName="asean"
          verticalBlockTitle="ASEAN"
        />
      </Container>

      <NewsletterSignUpPanel
        rootClassName="mb-3"
        descriptionComponent={<AseanNewsletterDescription />}
        newsletter={BT_NEWSLETTERS.filter(
          (newsletter) => newsletter.type === NEWSLETTER_TYPE.ASEAN
        )}
        btnColors="bg-verticals-asean text-white hover:bg-white hover:text-verticals-asean"
        linkColors="text-verticals-asean"
      />

      {/* Placeholder for asean footer banner component, will be replaced once done */}
    </div>
  );
}
